import { FC, useEffect } from 'react';
import { useField } from 'formik';
import { FieldGroup, IFormProps, InputNumber } from '.';
import IntegerControlViewModel from '../Models/IntegerControlViewModel';

interface IIntegerControlProps extends IFormProps {
	model: IntegerControlViewModel;
}

const IntegerControl: FC<IIntegerControlProps> = ({
	model,
	readOnly,
	setFieldValue,
}) => {
	const [inputProps, , helperProps] = useField(model.FullPath);

	useEffect(() => {
		helperProps.setValue(model.Value, true);
		// eslint-disable-next-line
	}, [model.Value]);

	const onChangeValue = (value: any) => {
		return setFieldValue(model.FullPath, value);
	};

	return (
		<FieldGroup
			hidden={!model.ControlVisibility}
			name={model.FullPath}
			title={model.Caption}
			width={model.Width ?? 12}
			readOnly={!model.ControlEnabling || readOnly}
			isInvalid={model.notValidClass}
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			<InputNumber
				{...inputProps}
				isInvalid={model.notValidClass}
				readOnly={readOnly || !model.ControlEnabling}
				onChangeValue={onChangeValue}
				mode={'floating'}
				isClearBtn={false}
			/>
		</FieldGroup>
	);
};

export default IntegerControl;
